import { render, staticRenderFns } from "./Scrollable.vue?vue&type=template&id=bd15e8be&scoped=true"
import script from "./Scrollable.vue?vue&type=script&lang=js"
export * from "./Scrollable.vue?vue&type=script&lang=js"
import style0 from "./Scrollable.vue?vue&type=style&index=0&id=bd15e8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd15e8be",
  null
  
)

export default component.exports